










import { Vue , Component} from 'vue-property-decorator';
import API from '@/Api';
@Component
export default class PersonalDetailsPopUp extends Vue {
    public dialog: boolean = true;
    public items: any = [];
    public mounted() {
        this.load();
    }
    public load() {
        API.Instance.get('/api/personal-detail-check')
        .then((response) => {
            this.items = response.data;
        });
    }
    public redirect() {
        return '/personal-details/' + this.items.employeeDetailId;
    }
}
